import React, { useState } from 'react';
import HeaderDropdown, { DropdownCard, DropdownCardsGrid } from './HeaderDropdown';

const InsuranceDropdown = ({ isOpen, onMouseEnter, onMouseLeave }) => {
    const [activeTab, setActiveTab] = useState('life');

    const categories = [
        { id: 'life', label: 'Life Insurance' },
        { id: 'health', label: 'Health Insurance' },
        { id: 'motor', label: 'Motor Insurance' }
    ];

    const insuranceProducts = {
        life: [
            { icon: '🛡️', title: 'Term Insurance', desc: 'Security and peace for life\'s unpredictability', href: '/#term-insurance' },
            { icon: '🍵', title: 'Retirement Plans', desc: 'Guaranteed pension plus lump sum on maturity', href: '/#retirement-plans' },
            { icon: '🐷', title: 'Savings Plans', desc: 'Build wealth with guaranteed returns', href: '/#savings-plans' },
            { icon: '💰', title: 'ULIP Plans', desc: 'Insurance & wealth creation in one plan', href: '/#ulip-plans' }
        ],
        health: [
            { icon: '♡', title: 'Health & Wellness', desc: 'Quality health care made affordable', href: '/#health-wellness', highlight: true },
            { icon: '🎗️', title: 'Super Top-up Plans', desc: 'Extra coverage when you need it most', href: '/#super-top-up' },
            { icon: '💳', title: 'Health Saver Card', desc: 'Reduce expenses while staying healthier', href: '/#health-saver' }
        ],
        motor: [
            { icon: '🏍️', title: 'Bike Insurance', desc: 'Comprehensive protection for two-wheelers', href: '/#bike-insurance' },
            { icon: '🚗', title: 'Car Insurance', desc: 'Protection against liabilities and damage', href: '/#car-insurance' }
        ]
    };

    const currentProducts = insuranceProducts[activeTab] || [];

    return (
        <HeaderDropdown
            isOpen={isOpen}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            categories={categories}
            activeCategory={activeTab}
            onCategoryHover={setActiveTab}
        >
            <DropdownCardsGrid columns={2}>
                {currentProducts.map((product, index) => (
                    <DropdownCard
                        key={index}
                        href={product.href}
                        icon={product.icon}
                        title={product.title}
                        description={product.desc}
                        highlight={product.highlight}
                    />
                ))}
            </DropdownCardsGrid>
        </HeaderDropdown>
    );
};

export default InsuranceDropdown;
